import { render, staticRenderFns } from "./partyActiveSign.vue?vue&type=template&id=2590c4b9&"
import script from "./partyActiveSign.vue?vue&type=script&lang=js&"
export * from "./partyActiveSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports